import {useLayoutEffect, useMemo, useRef, useState} from 'react'
import {NODE_HEIGHT, NODE_WIDTH} from '../constants'

const useMinScale = ({treeData}) => {
  const canvasSizes = useMemo(() => {
    return {
      width: treeData.canvas.width * NODE_WIDTH,
      height: treeData.canvas.height * NODE_HEIGHT,
    }
  }, [treeData.canvas.height, treeData.canvas.width])

  const wrapperRef = useRef(null)
  const [wrapperSizes, setWrapperSizes] = useState()

  const updateWrapperSize = () => {
    // console.log('### updateWrapperSize')
    setWrapperSizes({
      height: wrapperRef.current?.offsetHeight,
      width: wrapperRef.current?.offsetWidth,
    })
  }

  const timeooutUpdateWrapperSizeRef = useRef(null)

  useLayoutEffect(() => {
    const delayedUpdate = (delay = 100) => {
      clearTimeout(timeooutUpdateWrapperSizeRef.current)
      timeooutUpdateWrapperSizeRef.current = setTimeout(() => {
        timeooutUpdateWrapperSizeRef.current = null
        updateWrapperSize()
      }, delay)
    }

    window.addEventListener('resize', delayedUpdate)
    delayedUpdate(100)

    return () => window.removeEventListener('resize', delayedUpdate)
  }, [])

  const minScale = useMemo(() => {
    // console.log('### wrapperSizes', wrapperSizes)
    // console.log('### canvasSizes', canvasSizes)
    if (wrapperSizes && canvasSizes) {
      const heightScale = (wrapperSizes.height || wrapperSizes.width) / canvasSizes.height
      // console.log('### heightScale', heightScale)
      const widthScale = wrapperSizes.width / canvasSizes.width
      // console.log('### widthScale', widthScale)

      return Math.min(heightScale, widthScale, 1) * 0.9
    }
  }, [wrapperSizes, canvasSizes])

  // console.log('### minScale', minScale)
  return {wrapperRef, minScale}
}

export default useMinScale
